<template>
  <div class="pa-2">
    <div class="f_20 mt-3 font_bold">
      {{ questionOrder }} - {{ questionTitle }}
    </div>

    <div class="mt-4 image_galdiv" v-if="coverType == 'image'">
      <Splide :options="{ rewind: true, arrows: false }">
        <SplideSlide v-for="image in coverImages" :key="image.imageId">
          <img
            :src="VUE_APP_QUESTION_MEDIA + image.image"
            style="width: 100%"
          />
        </SplideSlide>
      </Splide>
    </div>
    <div class="mt-4 image_viddiv" v-if="coverType == 'video'">
      <video width="100%" height="auto" controls controlsList="nodownload">
        <source :src="coverVideo" type="video/mp4" />
      </video>
    </div>
    <div class="mt-4" v-if="coverType == 'sound'">
      <audio controls class="audio_shadow audio_w" controlsList="nodownload">
        <source :src="coverSound" type="audio/mp3" />
      </audio>
      <v-btn
        class="ml-3 mt-n10"
        @click="dialogSound = !dialogSound"
        icon
        outlined
        color="secondary"
        depressed
        elevation="2"
        dark
        ><v-icon class="mt-n1" size="20">{{
          icons.mdiFormatAlignLeft
        }}</v-icon></v-btn
      >
    </div>
    <div class="mt-4 text-pre-wrap" v-if="coverType == 'text'">
      <span v-html="markup_do(coverText)"></span>
    </div>

    <div class="mt-5 row">
      <div class="col-12">
        <ol :type="listing_symbol">
          <li
            v-for="item in pair_click_list2_items"
            :key="item.pairId"
            class="mb-5 text-pre-wrap"
          >
            <span v-html="markup_do(item.text_pre)"></span>

            <div :class="classbosluk(item.pairId)">
              <draggable
                class="dragArea dragAreabefore"
                group="mainlist"
                @start="startdragging"
                @change="log($event, item.pairId)"
                @end="enddragging"
                v-model="item.list"
              >
                <v-chip
                  label
                  v-for="item in item.list"
                  :id="item.wordId"
                  :key="item.wordId"
                  color="white"
                  class="draggable_options"
                  ><span class="color_black">{{ item.content }}</span></v-chip
                >
              </draggable>
            </div>
            <span v-html="markup_do(item.text_post)"></span>
          </li>
        </ol>
      </div>
      <div class="col-12 text-center mt-5">
        <v-chip
          v-if="this.word_list.length == 0"
          color="grey lighten-2 "
          style="width:100px"
          class="ma-1"
        ></v-chip>
        <draggable
          class="dragArea"
          group="mainlist"
          @start="startdragging"
          @end="enddragging"
          @change="kasa"
          v-model="word_list"
        >
          <v-chip
            label
            v-for="item in word_list"
            :id="item.wordId"
            :key="item.wordId"
            color="white"
            class="ma-1 draggable_options"
            ><span class="color_black">{{ item.content }}</span></v-chip
          >
        </draggable>
      </div>
    </div>

    <v-dialog v-model="dialogSound" max-width="600px">
      <v-card>
        <div
          class="pa-4 text-pre-wrap"
          v-html="markup_do(coverSoundText)"
        ></div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import "@/styles/main.css";
import { mdiFormatAlignLeft } from "@mdi/js";
import "@splidejs/splide/dist/css/splide.min.css";
import { Splide, SplideSlide } from "@splidejs/vue-splide";
import axios from "axios";
import draggable from "vuedraggable";
import markup from "../../../mixins/markup";

export default {
  mixins: [markup],
  components: { Splide, SplideSlide, draggable },
  data: () => ({
    VUE_APP_API_DOMAIN: "",
    VUE_APP_QUESTION_MEDIA: process.env.VUE_APP_QUESTION_MEDIA,
    questionOrder: null,
    questionTitle: "",
    coverType: "",
    coverVideo: "",
    coverSound: "",
    coverSoundText: "",
    coverText: "",
    listing_type: "",
    listing_symbol: "",
    coverImages: null,
    pair_click_list2_items: null,
    pair_click_list2_words: null,

    selected_wordId: 0,

    word_list_original: [],
    word_list: [],

    dialogSound: false,
  }),
  props: {
    questionId: String,
  },
  methods: {
    classbosluk(id) {
      let res = "chip_white_border_paragraph mt-1";

      this.pair_click_list2_items.forEach((e) => {
        if (e.pairId == id && e.list.length >= 1) {
          res = "chip_white_border_paragraph_full mt-1";
        }
      });

      return res;
    },

    goingData() {
      let dat = {
        questionId: this.questionId,
        questionType: "pair_click_list2",
        answerDetails: [],
      };

      this.pair_click_list2_items.forEach((e) => {
        dat.answerDetails.push({
          pairId: e.pairId,
          reply: e.list[0].wordId,
        });
      });

      return dat;
    },

    test() {
      console.log(this.pair_click_list2_items);
      console.log(this.goingData());
    },

    selectItem() {
      let allOk = true;
      this.pair_click_list2_items.forEach((e) => {
        if (e.list.length == 0) {
          allOk = false;
        }
      });

      this.$emit("makeAllAnswered", allOk);
    },

    correctQuestion() {
      this.resetQuestion();
      this.pair_click_list2_items.forEach((e) => {
        this.word_list_original.forEach((t) => {
          if (t.wordId == e.wordId) {
            e.list.push({
              wordId: t.wordId,
              content: t.content,
            });
          }
        });
      });

      this.word_list = [];
    },
    resetQuestion() {
      this.word_list = this.word_list_original;
      this.pair_click_list2_items.forEach((e) => {
        e.list = [];
      });
    },
    reload() {
      this.$forceUpdate();
      this.selectItem();
    },

    startdragging(env) {
      console.log("dragging id:" + env.clone.id);
      this.selected_wordId = env.clone.id;
    },
    enddragging() {
      this.reload();
    },
    kasa() {
      console.log("kasa değişti");
    },
    log(evt, pairId) {
      this.pair_click_list2_items.forEach((e) => {
        if (e.pairId == pairId) {
          let li = 0;
          e.list.forEach((y) => {
            if (y.wordId != this.selected_wordId) {
              this.word_list.push({
                wordId: y.wordId,
                content: y.content,
              });
              e.list.splice(li, 1);
              this.selected_wordId = 0;
            }
            li++;
          });
        }
      });
    },

    shuffle1(array) {
      return array.sort(() => Math.random() - 0.5);
    },

    getData() {
      const data = { questionId: this.questionId };
      axios
        .post(
          process.env.VUE_APP_API_DOMAIN + "/s_student_question_details",
          JSON.stringify(data),
          {
            headers: {
              Authorization: "Bearer " + this.$store.getters.getAccessToken,
            },
          }
        )
        .then((response) => {
          this.questionOrder = response.data.questionOrder;
          this.questionTitle = response.data.questionTitle;
          this.coverType = response.data.coverType;
          this.coverVideo = response.data.coverVideo;
          this.coverSound = response.data.coverSound;
          this.coverSoundText = response.data.coverSoundText;
          this.coverText = response.data.coverText;
          this.coverImages = response.data.coverImages;
          this.listing_type = response.data.listing_type;
          this.listing_symbol = response.data.listing_symbol;
          this.pair_click_list2_items = response.data.pair_click_list2_items;
          this.pair_click_list2_words = response.data.pair_click_list2_words;

          this.pair_click_list2_items.forEach((element) => {
            element.list = [];
          });
          this.pair_click_list2_words.forEach((e) => {
            this.word_list.push({
              wordId: e.wordId,
              content: e.content,
            });
            this.word_list_original.push({
              wordId: e.wordId,
              content: e.content,
            });
          });

          this.word_list = this.shuffle1(this.word_list);
          this.word_list_original = this.shuffle1(this.word_list_original);
        });
    },
  },
  setup() {
    return {
      icons: { mdiFormatAlignLeft },
    };
  },
  created() {
    this.VUE_APP_API_DOMAIN = process.env.VUE_APP_API_DOMAIN;
  },
  mounted() {
    this.getData();
  },
};
</script>
